/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 * @flow strict-local
 */

import React, {PureComponent} from 'react'
import {Dimensions, View} from 'react-native'
import {Avatar, Text, Icon} from 'react-native-elements'

import {RecyclerListView, DataProvider, LayoutProvider} from 'recyclerlistview'

const WIDTH = Dimensions.get('window').width
const HEIGHT = Dimensions.get('window').height

class MediaList extends PureComponent {
  constructor (props) {
    super(props)
    this.dataProvider = new DataProvider((r1, r2) => {
      return r1 !== r2
    })

    this.layoutProvider = new LayoutProvider(
      () => {
        return 'NORMAL'
      },
      (type, dim) => {
        switch (type) {
          case 'NORMAL':
            dim.width = 150
            dim.height = 200
            break
          default:
            dim.width = 0
            dim.height = 0
        }
      },
    )
  }

  _rowRenderer = (type, data) => {
    switch (type) {
      case 'NORMAL':
        return (
          <View style={{margin: 10}}>
            {data.mime_type.startsWith('image') ? (
              <Avatar
                source={{uri: data.media_details.sizes.thumbnail.source_url}}
                size={150}
                onPress={() => {
                  this.props.onFileSelect(data)
                }}
              />
            ) : data.mime_type.startsWith('video') ? (
              <Icon
                containerStyle={{
                  backgroundColor: 'grey',
                  width: 150,
                  height: 150,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                name='video'
                type='font-awesome-5'
                color='white'
                size={50}
                onPress={() => {
                  this.props.onFileSelect(data)
                }}
              />
            ) : (
              <Icon
                containerStyle={{
                  backgroundColor: 'grey',
                  width: 150,
                  height: 150,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                name='file'
                type='font-awesome-5'
                color='white'
                size={50}
                onPress={() => {
                  this.props.onFileSelect(data)
                }}
              />
            )}

            <Text style={{fontSize: 10}}>{data.title.rendered}</Text>
          </View>
        )
      default:
        return null
    }
  }

  reference = ref => {
    this.recyclerList = ref
  }

  loadList = () => {
    return (
      <RecyclerListView
        ref={this.reference}
        dataProvider={this.dataProvider.cloneWithRows(this.props.data)}
        layoutProvider={this.layoutProvider}
        rowRenderer={this._rowRenderer}
      />
    )
  }

  render () {
    return this.loadList()
  }
}
export default MediaList
